export function userIsNew(
  firstName: string | null | undefined,
  lastName: string | null | undefined
): boolean {
  return !(firstName && lastName)
}
